import { createFeatureSelector } from '@ngrx/store';
import { BaseState } from './lobby.reducer';
import { Area, AreaRoomData, DynamicContent, Site, SiteType, UserRole } from '@shared/models';


export const selectSiteTypes = createFeatureSelector<BaseState<SiteType>>('siteTypes');

export const selectSites = createFeatureSelector<BaseState<Site>>('sites');

export const selectAreas = createFeatureSelector<BaseState<Area>>('areas');

export const selectRooms = createFeatureSelector<BaseState<AreaRoomData>>('rooms');

export const selectDynamicContent = createFeatureSelector<BaseState<DynamicContent>>('dynamicContent');

export const selectUserRoles = createFeatureSelector<BaseState<UserRole>>('userRoles');
